import { buttonState } from './buttonState';

const useButtonStates = () => ({ buttonState });

export default useButtonStates;
